/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>价目</el-breadcrumb-item>
      <el-breadcrumb-item>全国统一零售价</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
       
        
        
		<el-form label-width="120px" ref="editForm" class="editForm">
		 
		 
		 
		 <el-form-item  label="文件信息">
		   <!-- accept=".png,.jpeg,.gif,.pdf,.jpg,.JPG" -->
		   <el-upload
		     class="upload-files"
		     v-model="diaFrom.list"
		     :limit="1"
		     :on-exceed="handleExceed"
		     :on-preview="handlePreview"
		     :before-upload="beforeAvatarUpload"
		     :on-remove="handleRemove"
		     :on-success="onUploadSuccess"
		     :file-list="resultFilelist"
		     list-type="picture"
		     :action="uploadUrl()"
		     :http-request="customUpload"
		     accept=".pdf,.doc,.docx,.ppt,pptx">
		     <el-button size="small" type="primary">点击上传文件</el-button>
		     <div slot="tip" class="el-upload__tip">上传文件，仅支持PDF文件、WORD文档、PPT文件，最多可上传1份文件</div>
		     
		   </el-upload>
		 </el-form-item>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">预览</el-button>
		  </div>
		  
		  
		  
		  
		</el-form>
		
		
		
		
		
		
		
		
		
      </div>
    </template>

    <script>
    // 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      saveUniformRetailPrice,
	  getUniformRetailPrice,
	  deleteUniformRetailPrice
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
		  diaFrom:{
		    desc:'',
		    list:[]
		  },
         resultFilelist:[]
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.handleEdit()

      },
      mounted(){
		 
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  dealPDF(){
		      var liElements = document.querySelectorAll('ul.el-upload-list,el-upload-list--picture li.el-upload-list__item');
		      liElements.forEach(function(liElement){
		        var aElement = liElement.querySelector('a.el-upload-list__item-name');
		        if(aElement && (aElement.textContent.includes('.pdf') || aElement.textContent.includes('.doc') || aElement.textContent.includes('.docx') || aElement.textContent.includes('.ppt') || aElement.textContent.includes('.pptx'))){
		          var imgElement = liElement.querySelector('img.el-upload-list__item-thumbnail')
		          if(imgElement){
		            imgElement.src= require('../../assets/img/pdf.png');// 普换为你想要的新图片的URL
		          }
		        }
		      })
		  },
		  onUploadSuccess(response,file,fileList){
		    console.log('onUploadSuccess',response)
		    
		  },
		  beforeAvatarUpload(file){
		    console.log(file)
		  },
		  //限制上传个数不超过9个
		  handleExceed(files,fileList){
		    if(fileList && fileList.length == 1){
		      this.$message.warning('上传文件不可超过1个')
		    }
		  },
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getUniformRetailPrice().then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         let data = res.data
		        
				 this.resultFilelist = []
				
				 
				this.resultFilelist.push({
				  url:require('../../assets/img/pdf.png'),
				  fileTemporaryUrl:data.fileInfo.fileTemporaryUrl,
				  fileId:data.fileInfo.fileId,
				  name: data.fileInfo.ossFile.fileName,
				})
				   
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		  uploadUrl(){
		    return '/mtl/marking/api/main/oss-file/upload-file'
		  },
		  handlePreview(file){
		    console.log(file)
		   
		  },
		  
		  customUpload(req){
		    let _this = this
		    console.log(req)
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
		    
		      uploadFile(this.uploadUrl(), formData).then(response => {
				 
		        if(response.data.success){
		          let data = response.data.data
		          console.log(data)
		          _this.resultFilelist.push({
		                  url:require('../../assets/img/pdf.png'),
		                  fileTemporaryUrl:data.fileTemporaryUrl,
		                  fileId:data.fileId,
		                  name: data.ossFile.fileName,
		                  uid: req.file.uid,
		                  mediaObjInfo:data
		              })
		            
		          _this.saveProInfo()
		          
		        }else{
		          this.$message.error('文件上传失败，请稍后再试！')
		        }
		       console.log(99999999,_this.resultFilelist)
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		        console.log(error)
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		 
		  handleRemove(file,fileList){
		    let _this = this
		    console.log(file)
		    if(!file){
		      return
		    }
		    const index = this.resultFilelist.findIndex(item => item.fileId === file.fileId)
		     console.log(index)
		     this.resultFilelist.splice(index,1);
			 this.deleInfo()
		  },
		 
		
		
     
		 
        
        
        // 编辑、添加提交方法
        saveProInfo(){
           
			let formProInfo = this.resultFilelist[0].mediaObjInfo
            saveUniformRetailPrice(formProInfo).then(res => {
              console.log(123)
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
               this.$message({
                 type: 'success',
                 message: '上传成功'
               })
              }
            })
    		
        },

       deleInfo(){
           deleteUniformRetailPrice().then(res => {
             console.log(123)
             this.loading = false
             if (res.success == false) {
               this.$message({
                 type: 'info',
                 message: res.msg
               })
             } else {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
             }
           })
       	
       },


      }
    }
    </script>

    <style scoped>
    .user-search {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 100px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		width: 90%;
		height: 85%;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  width: 600px;
	  height: 100%;
	  display: grid;
	  place-items: center;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
    </style>





// WEBPACK FOOTER //
// src/views/markedprice/retailprice.vue